import { useRef, useCallback, useEffect } from 'react';

// src/lifecycle/use-mounted-state.ts
function useMountedState() {
  const mountedRef = useRef(false);
  const get = useCallback(() => mountedRef.current, []);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return get;
}

export { useMountedState };
